












import Vue from 'vue';

export default Vue.extend({
    methods: {
        async logout() {
            await this.$store.dispatch('company/login/logout').then((response) => {
                this.$toast.show({
                    type: 'success',
                    message: 'Successfully logged out!',
                });
                this.$store.commit('company/register/setCurrentStep', 1);
                this.$router.push(this.localePath({ path: '/login' }));
            });
        },
    },
});
